import { render, staticRenderFns } from "./BadgeCellRenderer.vue?vue&type=template&id=8e3cf960&scoped=true"
import script from "./BadgeCellRenderer.vue?vue&type=script&lang=js"
export * from "./BadgeCellRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e3cf960",
  null
  
)

export default component.exports